<template>
  <el-container>
    <el-header class="table-header">
      <router-link :to="{name: 'addDictionary'}">
        <el-button type="primary" size="small">{{$t('common.Add')}}</el-button>
      </router-link>
      <el-button icon="el-icon-search" align="center" @click="search('refresh')" size="small">{{$t('common.Search')}}</el-button>
        <el-button icon="el-icon-refresh-left" align="center" @click="formSearch={}" size="small">{{$t('common.Reset')}}</el-button>
    </el-header>
      <el-main class="table-main">
        <el-form :model="formSearch" ref="fromSearch" label-width="80px" class="table-form" size="mini">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.info.dict.DictionaryTypeCode')" prop="code">
                <el-input v-model="formSearch.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.dict.DictionaryTypeName')" prop="name">
                <el-input v-model="formSearch.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.SystemName')" prop="systemId">
                <el-select v-model="formSearch.systemId" size="mini">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="tableData"
          style="width: 100%" border stripe>
          <el-table-column
            type="index">
          </el-table-column>
          <el-table-column
            prop="systemId"
            :formatter="systemName"
            :label="$t('common.SystemName')"
            width="120%">
          </el-table-column>
          <el-table-column
            prop="code"
            width="130%"
            :label="$t('base.info.dict.DictionaryTypeCode')">
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('base.info.dict.DictionaryTypeName')"
            width="130%">
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('common.Type')"
            align="center"
            width="90%">
            <template slot-scope="scope">
              <span v-if="scope.row.type===80">{{$t('common.Default')}}</span>
              <span v-if="scope.row.type===10">{{$t('common.Customize')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('common.Remark')"
            width="160%">
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('common.Status')"
            align="center"
            width="60%">
            <template slot-scope="scope">
              <span v-if="scope.row.status===50">{{$t('common.Normal')}}</span>
              <span v-if="scope.row.status===40">{{$t('common.Disable')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="modifyUserName"
            :label="$t('common.ModifyUser')"
            width="100%">
          </el-table-column>
          <el-table-column
            prop="modifyTime"
            :label="$t('common.ModifyTimeDetail')"
            align="center"
            width="160%"
            :formatter="dateFormat2">
          </el-table-column>
          <el-table-column align="center" :label="$t('common.Operate')" width="150px">
            <template slot-scope="scope">
              <router-link :to="{name:'updateDictionary',path:'/updateDictionary',params: {row:scope.row}}">
                <el-button size="mini" type="text">{{$t('common.Edit')}}</el-button>
              </router-link>
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.$index, scope.row)">{{$t('common.Delete')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    <el-footer class="table-footer">
      <table-page ref="dictionaryListPage" :url="dictionaryListUrl" :form="formSearch" @page-change="convert"></table-page>
    </el-footer>
  </el-container>
</template>

<script>
import moment from 'moment'
import TablePage from '@/components/TablePage'

export default {
  data () {
    return {
      tableData: [],
      dictionaryListUrl: this.global.BASE_INFO + '/dict/findAll',
      dialogFormVisible: false,
      options: [],
      formSearch: {
        code: '',
        name: '',
        systemId: ''
      }
    }
  },
  components: {
    TablePage
  },
  methods: {
    dateFormat (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormat2 (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm ')
    },
    handleDelete (index, row) {
      this.$confirm(this.$t('common.DeleteConfirm'), this.$t('common.Confirm'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.dictionary.dictDelete(this.qs.stringify({id: row.id}))
          .then((response) => {
            this.$refs['dictionaryListPage'].getTableData()
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.DeleteCancelResult')
        })
      })
    },
    /* initSystemId () {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/system/findSystemId',
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        for (let i in response.data.data) {
          this.options.push({value: i})
        }
      }).catch((error) => {
        console.log(error)
      })
    }, */
    initSysData () {
      this.$api.systemList.systemFindSystem().then((response) => {
        response.data.data.map((value, i) => {
          this.options.push({label: value.name, value: value.id})
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    systemName (row, column) {
      let item = this.options.find(item => {
        return item.value === row[column.property]
      })
      return item && item.label
    },
    convert (table) {
      this.tableData = table.data
    },
    search (param) {
      this.$refs['dictionaryListPage'].getTableData(param)
    }
  },
  created () {
    this.initSysData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/dictionary/dictionary.vue